<a
  (mouseenter)="cardHovered = true"
  (mouseleave)="cardHovered = false"
  [class.hovered]="cardHovered || outlined()"
  (click)="openVideo()"
>
  <mat-card appearance="outlined">
    @if (!loadedSuccessfully()) {
    <img mat-card-image [src]="'assets/images/video-default-thumbnail.jpg'" />
    <img
      style="display: none"
      [src]="video().thumbnailUrl"
      (load)="loadedSuccessfully.set(true)"
      (error)="loadedSuccessfully.set(false)"
      [alt]="video().title"
    />
    }@else {
    <img mat-card-image [src]="video().thumbnailUrl" />
    }

    <mat-card-content>
      <h3 class="video-title">{{ video().title }}</h3>
      <span class="video-speaker">{{ video().preacher }}</span>
      <span class="video-date"> {{ video().date | date : "MMM d, y" }}</span>
    </mat-card-content>
  </mat-card>
</a>
